<template>
  <v-dialog v-model="showDialog" max-width="300" persistent @keydown.esc="close">
    <v-card>
      <v-card-title class="primaryDialogTitle">
        <span>Action</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row class="justify-center">
          <v-col cols="12">
            <v-btn
              class="full-width mb-3"
              elevation="0"
              color="primary"
              large
              @click="selectAction('rest')"
            >
              Block Time slot
            </v-btn>
            <v-btn
              class="full-width mb-3"
              elevation="0"
              color="primary"
              large
              @click="selectAction('create')"
            >
              Create New Booking
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <TakeRestDialog
      v-if="column"
      v-model="showTakeRest"
      @close="closeSubDialog"
      @create="handleRestCreate"
      :date="date"
      :clinic="column.clinic"
      :time="timeStart"
    />

    <BookingEditDialog
      v-model="showNewBooking"
      id="new"
      title="Create New Booking"
      :preselectedDate="date"
      :preselectedTime="time"
      :preselectedClinic="column && column.clinic ? column.clinic._id : null"
      @close="closeSubDialog"
      @create="handleBookingCreate"
      @update="handleBookingUpdate"
    />
  </v-dialog>
</template>

<script>
import { IDateRange } from '@/api/mongooseTypes';
import TakeRestDialog from '@/components/Timetable/TakeRestDialog';
import BookingEditDialog from '@/components/Booking/BookingEditDialog';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'EmptyCellAction',
  components: { TakeRestDialog, BookingEditDialog },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    date: Date,
    column: {
      // _id: string,
      // master: IMasterProfile,
      // columnIndex: number,
    },
    time: {
      // start: Date,
      // end: Date,
    },
    events: {},
  },
  data() {
    return {
      showTakeRest: false,
      showNewBooking: false,
      defaultBookingDuration: 0,
    };
  },
  computed: {
    ...mapGetters('auth', ['isClinicStaff']),
    showDialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    timeStart() {
      return new IDateRange({
        start: this.time.start,
        end: moment(this.time.start).add(this.defaultBookingDuration).toDate(),
      });
    },
  },
  watch: {
    showDialog(v) {
      if (v) {
        this.showTakeRest = false;
        this.showNewBooking = false;
      }
    },
  },
  methods: {
    close() {
      this.showDialog = false;
    },
    selectAction(action) {
      switch (action) {
        case 'rest':
          this.showTakeRest = true;
          break;
        case 'create':
          // Calculate duration based on the cell's time range (typically 15 minutes)
          this.defaultBookingDuration = moment(this.time.end).diff(moment(this.time.start));
          this.showNewBooking = true;
          break;
      }
    },
    closeSubDialog() {
      // When sub-dialogs close, close the parent dialog as well
      this.showDialog = false;
      this.showTakeRest = false;
      this.showNewBooking = false;
    },
    handleRestCreate(rest) {
      this.$emit('create', rest);
      this.closeSubDialog();
    },
    handleBookingCreate(booking) {
      this.$emit('create', booking);
      this.closeSubDialog();
    },
    handleBookingUpdate(booking) {
      this.$emit('update', booking);
      this.closeSubDialog();
    },
  },
};
</script>
